performance.mark('start_load_main');

import Form from './core/Form';
import * as helpers from './core/Functions';

// require('es6-promise').polyfill();
Lang.setLocale(siteLang);

window.helpers = helpers;
window.Form = Form;

// глобальный объект для модалок
window.modal = {
    type: '',
    country: '',
    resort: '',
};

require('./snippets/header');
require('./snippets/common');
require('./snippets/callback');
require('./snippets/auth');
require('./snippets/counter');


//lazy image load
import Blazy from 'blazy';

window.Blazy = Blazy;

setTimeout(function () {
    new Blazy({
        breakpoints: [{
            width: 420,
            src: 'data-src-small'
        }]
    });
}, 500);


performance.mark('main_loaded');






// WEBPACK FOOTER //
// ./resources/assets/js/main.js